export const fullName = (user) => {
  const firstName = user.preferredName || user.firstName || '';
  const lastName = user.preferredLastName || user.lastName || '';
  return `${firstName} ${lastName}`;
};
